module.exports = __webpack_public_path__ + "static/media/gmail_icon.1ccd3616.png";